export const skeleton = {
  baseColor: '#F0F0F0',
  highlightColor: '#FAFAFA',
}
